import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly sessionId: string = crypto.randomUUID();

  getSessionId(): string {
    return this.sessionId;
  }
}
